import {map, get} from 'lodash';
import moment from 'moment';
import {inlineSchema} from './utils';
import i18n from '../i18n/index';
import * as Member from './membership';
import * as Appointment from './appointment';
import * as Order from './order';
import * as Transaction from './transaction';
import * as Product from './product';
import debug from '../debug';

let GN = 'fields.cat.general';

export default function () {
  return {
    notification_id: {type: 'id', required: true, cat: GN},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'},
    created_at: {type: 'datetime', readonly: true, cat: GN},
    read: {type: Boolean, default: false, cat: GN},

    //  notification role : npc ( non-person character )
    //  - for receiving / sending message
    sender: {type: 'schema', external: true, schema: Member},
    recipient: {type: 'schema', external: true, schema: Member},
    //
    // //  *** push notification
    // //  #1 get device tokens of member
    // //  #2 send push notification
    // //  #3 update here
    // push_notification_history: [{
    //   push_notification_id: {type: String, required: true},
    //   device_token: {type: String, required: true},
    //   send_at: {type: Date, required: true},
    // }], //  provided by client : appkey + device_uuid

    //  content
    content_type: {
      type: 'select',
      items: map(Object.keys(i18n.s('fields.content_types')), x => 'fields.content_types.' + x),
    },
    type: {
      label: 'fields.sub_type', type: 'string', hidden: !debug.DEBUG, list: !!debug.DEBUG,
    },
    'details.title': {cat: GN, type: 'i18n', itemType: {type: 'label'}, list: false},
    'details.content': {cat: GN, type: 'i18n', itemType: {type: 'label'}, list: false},
    // details: {
    //   cat: GN,
    //   expand: true,
    //   type: 'schema',
    //   schema: inlineSchema({
    //     //  sub_type
    //     title: {type: 'i18n', itemType: {type: 'label'}},
    //     content: {type: 'i18n', itemType: {type: 'label'}},
    //   }),
    // },
    ref: {
      cat: GN,
      hidden: !debug.DEBUG,
      type: 'schema', schema: inlineSchema({
        member: {type: 'schema', external: true, schema: Member},
        appointment: {type: 'schema', external: true, schema: Appointment},
        order: {type: 'schema', external: true, schema: Order},
        transaction: {type: 'schema', external: true, schema: Transaction},
        product: {type: 'schema', external: true, schema: Product},
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/schemas/notification_db.js